import { computed } from "mobx"
import { RacingStore } from "../../../data/store";
import { RacingRegionInfo } from "../../../data/models/RacingRegion"
/*
    Tests describing the structure of the ouput data should be written first.
    It would be better to split the tests into few suits:
    - base tests related to class and instance structure
    - business logic
    - edge cases
*/

export class RacingRegionSwitcherData {
    public provider: PageMethods;
    private racingStore: RacingStore;
    constructor(provider: PageMethods) {
        this.provider = provider;
        this.racingStore = RacingStore.getInstance;
    }

    @computed get regions(): RacingRegionInfo[] {
        return this.racingStore.regions.filter(
            /* istanbul ignore next */
            x => x.hasEvents
        );
    }

    setParams(regionId: number, branchId: number) {
        this.racingStore.setParams(regionId, branchId);
    }
}